// 장소(Location)
//
// store/index.js 가 이 조각들을 펼쳐 하나의 루트 스토어로 합친다.
// Vuex 의 modules 옵션이 아니라 "조각"인 이유: Vuex 는 namespaced 여부와 무관하게
// 모듈 state 를 모듈 이름 아래에 중첩시킨다. 진짜 모듈로 바꾸면 store.state.tasks 가
// store.state.tasks.tasks 가 되어 소비자 40곳을 전부 고쳐야 한다.
// 조각 합성은 동작이 100% 동일하면서 파일만 나눈다.
//
// **이 조각에는 state 가 없다.** 예전에는 locations 배열과 추가/수정/삭제 뮤테이션 넷을
// 들고 있었지만, 읽는 곳이 하나도 없었다 — EventDialog 와 장소 관리 화면은 둘 다
// fetchLocations 의 반환값을 자기 ref 에 담아 쓴다(UPDATE/DELETE 뮤테이션은 커밋하는
// 곳조차 없었다). events.js 와 같은 모양으로 서버 호출 래퍼만 남긴다.

import http from '@/utils/http'

export const actions = {
  async fetchLocations({ commit }) {
    try {
      const response = await http.get(`/api/locations`)
      return response.data.locations || []
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || '위치를 불러오는데 실패했습니다.')
      throw error
    }
  },

  async createLocation({ commit }, locationData) {
    try {
      const response = await http.post(`/api/locations`, locationData)
      return response.data.location
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || '위치 생성에 실패했습니다.')
      throw error
    }
  }
}
